<template>
  <section class="reg-placeholder" :data-testid="`reg-step-${stepKey}`">
    <h2 class="reg-placeholder__heading">{{ label }}</h2>
    <p class="reg-placeholder__note">{{ $t('registration.step_placeholder') }}</p>
  </section>
</template>

<script setup lang="ts">
/** Stands in for an unbuilt step; it has nothing to validate, so it allows next immediately. */
import { onMounted } from 'vue';

interface Props {
  stepKey: string;
  label: string;
}

defineProps<Props>();

/* ----------------------------------- STATE ---------------------------------- */
const allowNext = defineModel<boolean>('allowNext', { required: true });

/* ------------------------------ LIFECYCLE HOOKS ----------------------------- */
onMounted(() => {
  allowNext.value = true;
});
</script>

<style scoped lang="scss">
.reg-placeholder {
  max-width: 760px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__heading {
    margin: 0;
    font-size: 30px;
    line-height: 38px;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #101828;
  }

  &__note {
    margin: 0;
    font-size: 14px;
    line-height: 22px;
    color: #475467;
  }
}

@media (max-width: 767.98px) {
  .reg-placeholder__heading {
    font-size: 24px;
    line-height: 32px;
  }
}
</style>
